import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Alert } from 'roo-ui/components';
import { themeGet } from 'styled-system';

const StyledAlert = styled(Alert)`
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: ${themeGet('zIndices.alerts')};

  min-height: 48px;
  margin: 0;
  font-size: 16px;
  font-weight: bold;

  /** 0.5s-Down-Show > 5s-Stay-Show > 0.5-Up-Hide **/
  animation: 6s showAlert;
  animation-fill-mode: forwards;
  @keyframes showAlert {
    0% {
      transform: translateY(-100%);
      opacity: 1;
    }
    8.333% {
      transform: translateY(0);
      opacity: 1;
    }
    91.666% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(-100%);
      opacity: 0;
    }
  }

  > div > div {
    justify-content: center;
    > div {
      padding-right: 8px;
    }
  }
`;

const StickyAlert = ({ show, type, message }) =>
  show &&
  type &&
  message && (
    <StyledAlert variant={type} data-testid="sticky-alert" aria-live="assertive">
      {message}
    </StyledAlert>
  );

StickyAlert.defaultProps = {
  type: 'info',
  message: '',
  show: false,
};

StickyAlert.propTypes = {
  type: PropTypes.oneOf(['', 'success', 'info', 'error']),
  message: PropTypes.string,
  show: PropTypes.bool,
};

export default StickyAlert;
